import type { IconNode } from '../types';

/**
 * @name swiss-franc
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTBoNyIgLz4KICA8cGF0aCBkPSJNMTAgMjBWNWExIDEgMCAwMTEtMWg3IiAvPgogIDxwYXRoIGQ9Ik02IDE2aDkiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/swiss-franc
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 * @deprecated Removed because the depicted concept became obsolete and no longer had relevant use cases.
 */
const SwissFranc: IconNode = [
  ['path', { d: 'M10 10h7' }],
  ['path', { d: 'M10 20V5a1 1 0 011-1h7' }],
  ['path', { d: 'M6 16h9' }],
];

export default SwissFranc;
